import { useMemo } from "react"
import { createEnvironment, getCurrentEnvironmentType } from "./environment"
import { EnvironmentType } from "./envTypes"

export function useEnvironment() {
    const currentEnvType = getCurrentEnvironmentType()
    const currentEnv = useMemo(() => createEnvironment(), [currentEnvType])

    return {
        currentEnv,
    }
}

export function useMatchEnvironment(environments: EnvironmentType[]) {
    const { currentEnv } = useEnvironment()
    return environments.includes(currentEnv.type)
}
